import { render, staticRenderFns } from "./view-transfer-order.vue?vue&type=template&id=b4af1d68&"
import script from "./view-transfer-order.vue?vue&type=script&lang=ts&"
export * from "./view-transfer-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports